// The API still returns one flat row per Object-Lead link (or one row with null
// lead/company columns for an unlinked object) — grouping into one card per
// object, with all of its leads nested, happens here on the frontend. The
// backend's pagination already operates on distinct objects (see spSearchObjects),
// so every flat row belonging to the same object arrives together in one page.
export function groupRowsByObject(rows) {
    const order = [];
    const map = new Map();
    for (const row of rows) {
        let group = map.get(row.objectId);
        if (!group) {
            group = {
                objectId: row.objectId,
                objectIntId: row.objectIntId,
                objectName: row.objectName,
                street: row.street,
                houseNumber: row.houseNumber,
                postalCode: row.postalCode,
                city: row.city,
                pandId: row.pandId,
                objectStatus: row.objectStatus,
                statusLevel1Id: row.statusLevel1Id,
                statusLevel1Name: row.statusLevel1Name,
                leads: [],
                totalRows: row.totalRows,
            };
            map.set(row.objectId, group);
            order.push(row.objectId);
        }
        if (row.leadId && row.leadObjectId && row.leadNumber != null) {
            group.leads.push({
                leadObjectId: row.leadObjectId,
                leadId: row.leadId,
                leadNumber: row.leadNumber,
                leadStatus: row.leadStatus,
                companyId: row.companyId,
                companyName: row.companyName,
                chamberOfCommerce: row.chamberOfCommerce,
            });
        }
    }
    return order.map((id) => map.get(id));
}
